import axios from 'axios'

import type { RequestErrorData } from '@/contexts/shared/api/RequestError.interfaces'

export const getRequestErrorMessage = (error: Error): string => {
  if (axios.isAxiosError<RequestErrorData>(error) && error.response?.data?.message) {
    return error.response.data.message
  }

  return error.message
}
